import(/* webpackMode: "eager" */ "/opt/buildhome/repo/src/app/[locale]/error.tsx");
